/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Of_Use_LinkInputs */

const en_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Use`)
};

const id_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persyaratan Penggunaan`)
};

const ms_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terma Penggunaan`)
};

const ca_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condicions d'ús`)
};

const cs_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Use`)
};

const da_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brugsbetingelser`)
};

const de_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzungsbedingungen`)
};

const et_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teenusetingimused`)
};

const es_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Términos de uso`)
};

const fr_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conditions d’utilisation`)
};

const hr_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odredbe uporabe`)
};

const it_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termini d’uso`)
};

const lv_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lietošanas noteikumi`)
};

const lt_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naudojimo sąlygos`)
};

const hu_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Használati feltételek`)
};

const nl_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruiksvoorwaarden`)
};

const nb_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bruksvilkår`)
};

const pl_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regulamin`)
};

const pt_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termos de uso`)
};

const ro_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termeni și condiții`)
};

const sk_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podmínky použití`)
};

const sl_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pogoji uporabe`)
};

const fi_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käyttöehdot`)
};

const sv_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Villkor`)
};

const vi_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều khoản Sử dụng`)
};

const tr_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanım Koşulları`)
};

const el_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Όροι Χρήσης`)
};

const bg_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Условия за ползване`)
};

const ru_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Условия использования`)
};

const sr_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Услови коришћења`)
};

const uk_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Умови використання`)
};

const ka_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გამოყენების პირობები`)
};

const hi_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोग की शर्तें`)
};

const th_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อตกลงในการใช้งาน`)
};

const ko_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이용 약관`)
};

const zh_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用条款`)
};

const zh_tw_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用條款`)
};

const ja_terms_of_use_link = /** @type {(inputs: Terms_Of_Use_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用規約`)
};

/**
* | output |
* | --- |
* | "Terms of Use" |
*
* @param {Terms_Of_Use_LinkInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_of_use_link = /** @type {((inputs?: Terms_Of_Use_LinkInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Of_Use_LinkInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_of_use_link(inputs)
	if (locale === "ms") return ms_terms_of_use_link(inputs)
	if (locale === "ca") return ca_terms_of_use_link(inputs)
	if (locale === "cs") return cs_terms_of_use_link(inputs)
	if (locale === "da") return da_terms_of_use_link(inputs)
	if (locale === "de") return de_terms_of_use_link(inputs)
	if (locale === "et") return et_terms_of_use_link(inputs)
	if (locale === "es") return es_terms_of_use_link(inputs)
	if (locale === "fr") return fr_terms_of_use_link(inputs)
	if (locale === "hr") return hr_terms_of_use_link(inputs)
	if (locale === "it") return it_terms_of_use_link(inputs)
	if (locale === "lv") return lv_terms_of_use_link(inputs)
	if (locale === "lt") return lt_terms_of_use_link(inputs)
	if (locale === "hu") return hu_terms_of_use_link(inputs)
	if (locale === "nl") return nl_terms_of_use_link(inputs)
	if (locale === "nb") return nb_terms_of_use_link(inputs)
	if (locale === "pl") return pl_terms_of_use_link(inputs)
	if (locale === "pt") return pt_terms_of_use_link(inputs)
	if (locale === "ro") return ro_terms_of_use_link(inputs)
	if (locale === "sk") return sk_terms_of_use_link(inputs)
	if (locale === "sl") return sl_terms_of_use_link(inputs)
	if (locale === "fi") return fi_terms_of_use_link(inputs)
	if (locale === "sv") return sv_terms_of_use_link(inputs)
	if (locale === "vi") return vi_terms_of_use_link(inputs)
	if (locale === "tr") return tr_terms_of_use_link(inputs)
	if (locale === "el") return el_terms_of_use_link(inputs)
	if (locale === "bg") return bg_terms_of_use_link(inputs)
	if (locale === "ru") return ru_terms_of_use_link(inputs)
	if (locale === "sr") return sr_terms_of_use_link(inputs)
	if (locale === "uk") return uk_terms_of_use_link(inputs)
	if (locale === "ka") return ka_terms_of_use_link(inputs)
	if (locale === "hi") return hi_terms_of_use_link(inputs)
	if (locale === "th") return th_terms_of_use_link(inputs)
	if (locale === "ko") return ko_terms_of_use_link(inputs)
	if (locale === "zh") return zh_terms_of_use_link(inputs)
	if (locale === "zh-tw") return zh_tw_terms_of_use_link(inputs)
	if (locale === "ja") return ja_terms_of_use_link(inputs)
	return en_terms_of_use_link(inputs)
});